import Swal from "sweetalert2";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { const_routes } from "../helpers/const_routes";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

/* Se agregan en adelante metodos normales */

export const startLoadingModuleConfigurations = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MODULE_CONFIGURATION}`, "get");
    const body = await resp.json();

    debugLogActions(':: moduleConfigActions, startLoadingModuleConfigurations', { 'body': body });

    if (body.ok) {

      dispatch(loadingModuleConfigurations(body.moduleConfigurations));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingModuleConfigurations = (moduleConfigurations) => ({
  type: types.MODULE_CONFIGURATION_START_LOADING,
  payload: moduleConfigurations,
});

export const startLoadingModuleConfigurationsPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MODULE_CONFIGURATION}`, `get/${page}/${size}`);
    const body = await resp.json();

    debugLogActions(':: moduleConfigActions, startLoadingModuleConfigurationsPaginated', { 'body': body });

    if (body.ok) {

      dispatch(loadingModuleConfigurationsPaginated(body.moduleConfigPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingModuleConfigurationsPaginated = (moduleConfigurationPaginated) => ({
  type: types.MODULE_CONFIGURATION_START_LOADING_PAGINATED,
  payload: moduleConfigurationPaginated,
});

export const startLoadingModuleConfigurationsPaginatedByFilters = (page, size, componentFilters) => {
  return async (dispatch) => {

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MODULE_CONFIGURATION}`,
      `getP/${page}/${size}`,
      componentFilters,
      "POST");
    const body = await resp.json();

    debugLogActions(':: moduleConfigActions, startLoadingModuleConfigurationsPaginatedByFilters', { 'body': body });

    if (body.ok) {

      dispatch(loadingModuleConfigurationsPaginatedByFilters(body.moduleConfigPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingModuleConfigurationsPaginatedByFilters = (moduleConfigurationPaginated) => ({
  type: types.MODULE_CONFIGURATION_START_LOADING_PAGINATED,
  payload: moduleConfigurationPaginated,
});

export const selectModuleConfigurations = (moduleConfiguration) => ({
  type: types.MODULE_CONFIGURATION_SELECT,
  payload: moduleConfiguration,
});

export const moduleConfigurationClean = () => ({
  type: types.MODULE_CONFIGURATION_CLEAN,
});

export const moduleConfigurationStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_MODULE_CONFIGURATION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

              debugLogActions(':: moduleConfigActions, moduleConfigurationStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(moduleConfigurationDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                  Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: moduleConfigurationActions, moduleConfigurationStartDelete', { 'error': error });
    }
  };
};

const moduleConfigurationDeleted = (id) => {
  return {
    type: types.MODULE_CONFIGURATION_DELETE,
    payload: id,
  };
};

export const startSearchingModuleConfigurationsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MODULE_CONFIGURATION}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    debugLogActions(':: moduleConfigActions, startSearchingModuleConfigurationPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingModuleConfigurationsPaginated(body.moduleConfigurationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingModuleConfigurationsPaginated = (moduleConfigurationsPaginated) => ({
  type: types.MODULE_CONFIGURATION_START_SEARCH_PAGINATED,
  payload: moduleConfigurationsPaginated,
});

export const cleanSearchingModuleConfigurationsPaginated = () => ({
  type: types.MODULE_CONFIGURATION_CLEAN_SEARCH_PAGINATED,
});

export const moduleConfigurationStartUpdate = (moduleConfiguration, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_MODULE_CONFIGURATION}`,
        `update/${moduleConfiguration.id}`,
        moduleConfiguration,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: moduleConfigActions, moduleConfigurationStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(moduleConfigurationUpdated(moduleConfiguration));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-module-configuration");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: moduleConfigurationActions, moduleConfigurationStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} moduleConfiguration
 * @returns
 */
const moduleConfigurationUpdated = (moduleConfiguration) => {
  return {
    type: types.MODULE_CONFIGURATION_UPDATE,
    payload: moduleConfiguration,
  };
};

export const moduleConfigurationStartRegister = (moduleConfiguration, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MODULE_CONFIGURATION}`,
      "add",
      moduleConfiguration,
      "POST"
    );

    const body = await resp.json();

    debugLogActions(':: moduleConfigActions, moduleConfigurationStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(moduleConfigurationRegister(body.moduleConfiguration));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-module-configuration");
          }, 5000);
        }
      });



    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const moduleConfigurationRegister = (moduleConfiguration) => ({
  type: types.MODULE_CONFIGURATION_START_REGISTER,
  payload: moduleConfiguration,
});

export const moduleConfigurationSetSearchText = (searchText) => ({
  type: types.MODULE_CONFIGURATION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const moduleConfigurationCleanSearchText = () => ({
  type: types.MODULE_CONFIGURATION_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingModuleConfigurationsAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MODULE_CONFIGURATION}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingModuleConfigurationAll(body.moduleConfigurations));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingModuleConfigurationAll = (moduleConfigurations) => ({
  type: types.MODULE_CONFIGURATION_START_LOADING_ALL,
  payload: moduleConfigurations,
});